var App = App || {};
App.Initialization = App.Initialization || {};

App.Initialization['component.mobileNav'] = (function () {
    'use strict';

    const CONFIG = {
        OFFCANVAS_SELECTOR: ".offcanvas",
        BUTTONS_SELECTOR: "button[data-mobilenav]",
        LEVELS_SELECTOR: ".mobileNav__levels",
        LEVEL_SELECTOR: ".mobileNav__level",
        LEVEL_ATTRIBUTE: "data-level",
        ITEM_SELECTOR: ".mobileNav__level-item",
    };

    const initialize = (component) => {

        const offcanvas = component.closest(CONFIG.OFFCANVAS_SELECTOR);
        const levels = component.querySelector(CONFIG.LEVELS_SELECTOR);
        const buttons = component.querySelectorAll(CONFIG.BUTTONS_SELECTOR);

        if (offcanvas) {
            offcanvas.addEventListener('hidden.bs.offcanvas', event => {
                // if needed
            });
        }

        buttons.forEach(button => {

            button.addEventListener("click", function () {

                const currentLevel = parseInt(levels.getAttribute(CONFIG.LEVEL_ATTRIBUTE), 10);
                const currentItem = getCurrentItem(levels, currentLevel);
                const nextItem = getNextItem(this);
                const nextLevel = getLevel(nextItem);

                if (currentItem) currentItem.classList.remove("active");
                if (nextItem) nextItem.classList.add("active");
                levels.setAttribute(CONFIG.LEVEL_ATTRIBUTE, nextLevel);
            });
        });
    };

    const getCurrentItem = (levels, currentLevel) => {
        const currentLevelEl = levels.querySelector(`${CONFIG.LEVEL_SELECTOR}[${CONFIG.LEVEL_ATTRIBUTE}="${currentLevel}"]`);
        const currentItem = currentLevelEl ? currentLevelEl.querySelector(`${CONFIG.ITEM_SELECTOR}.active`) : null;
        return currentItem;
    };

    const getNextItem = (button) => {
        const id = button.getAttribute("aria-controls");
        return document.getElementById(id);
    };

    const getLevel = (el) => {
        return parseInt(
            el.closest(CONFIG.LEVEL_SELECTOR).getAttribute(CONFIG.LEVEL_ATTRIBUTE),
            10
        );
    };

    return {
        initialize
    };

})();